import { Group, Button, useMantineTheme } from "@mantine/core";
import { useForm } from "@mantine/form";
import { memo, useEffect } from "react";
import { useModals } from "@mantine/modals";
import useUserName from "src/hooks/useUserName";
import { useCreateMemberLoginMutation } from "src/generated/graphql";

type IFormProps = {
  username: string;
  clientId: string;
};

interface IProps {
  clientId: string;
  firstName: string | undefined;
  lastName: string | undefined;
  fetchClient?: () => void;
}

const AutoLoginGeneration = ({
  clientId,
  firstName,
  lastName,
  fetchClient,
}: IProps) => {
  const modals = useModals();
  const theme = useMantineTheme();
  const form = useForm<IFormProps>({
    initialValues: {
      username: "",
      clientId,
    },
  });
  const {
    isUsernameChecking,
    isUsernameLoading,
    isUsernameAvailable,
    getUserName,
    FieldUserName,
  } = useUserName(form);

  const [createMemberLogin, { loading: isCreating }] =
    useCreateMemberLoginMutation({
      onCompleted() {
        fetchClient && fetchClient();
        modals.closeAll();
      },
    });

  const handleSubmit = async (values: IFormProps) => {
    try {
      createMemberLogin({ variables: values });
    } catch (e: any) {
      console.error("Error: ", e.response);
    }
  };

  useEffect(() => {
    if (clientId && firstName && lastName)
      getUserName({ variables: { firstName, lastName } });
  }, [clientId, firstName, lastName]);

  return (
    <form onSubmit={form.onSubmit((values) => handleSubmit(values))}>
      {FieldUserName()}

      <Group position="apart" mt="md" style={{ marginTop: 30 }}>
        <Button
          radius="md"
          variant="outline"
          onClick={() => modals.closeAll()}
          style={{
            flex: 1,
            color: theme.colors.secondaryTextColor[6],
          }}
          sx={{
            backgroundColor: theme.colors.secondary[6],
            "&:hover": {
              background: theme.colors.secondary[5],
            },
          }}
        >
          Cancel
        </Button>
        <Button
          radius="md"
          type="submit"
          style={{
            flex: 1,
          }}
          sx={{
            color: theme.colors.primaryTextColor[6],
            "&:hover": {
              backgroundColor: theme.colors.primary[4],
            },
          }}
          disabled={
            isUsernameLoading || isUsernameChecking || !isUsernameAvailable
          }
          loading={isCreating}
        >
          Save
        </Button>
      </Group>
    </form>
  );
};

export default memo(AutoLoginGeneration);
